import axios from 'axios';

const parseParams = (params) => {
  const keys = Object.keys(params);
  let options = '';

  keys.forEach((key) => {
    const isParamTypeObject = typeof params[key] === 'object';

    if (!isParamTypeObject && typeof params[key] !== 'undefined' && params[key] !== '') {
      options += `${key}=${params[key]}&`;
    }

    if (isParamTypeObject && params[key] != null && params[key].length >= 0) {
      params[key].forEach((element) => {
        options += `${key}=${element}&`;
      });
    }
  });

  return options ? options.slice(0, -1) : options;
};

export const apiCall = async ({
  endPoint,
  method,
  payload,
  headers,
  params,
}) => {
  try {
    const result = await axios({
      method,
      url: endPoint,
      headers,
      data: payload,
      params,
      paramsSerializer: (params) => parseParams(params),
      // withCredentials: true,
    });
    return {
      response: result,
      error: null,
    };
  } catch (e) {
    // Trả full axios error để caller đọc được:
    //   - error.response.data.message  → message BE gửi (4xx/5xx có body JSON,
    //     ví dụ window guard "đã quá hạn nghiệm thu (đóng lúc 31/05/2026)").
    //   - error.response.status        → HTTP status code.
    //   - error.request.response       → raw response text (legacy caller
    //     internalResearch dùng `.includes(...)` trên chuỗi này).
    return {
      response: null,
      error: e,
    };
  }
};
